import { defineStore } from 'pinia';
import * as CoordenadasAtendimentoService from '@/services/coordenadasAtendimento';
import * as ApiService from '@/services/apiService';
import { isEmpty } from '@/helper/funcoes';

export const useAtendimentoStore = defineStore('atendimento', {
	state: () => ({
		atendimento: {},
		carregando: false,
		erro: false,
		expirado: false,
		statusAtendimento: '',
		chegadaConfirmada: '',
		idAtendimentoUrl: '',
		totalServicos: 0,
		temAnexos: false,
		coordenadasAtendimento: []
	}),

	getters: {
		servico: (state) => {			
			return (idServicoAtendimento) => state.atendimento.servicos[idServicoAtendimento]
		}
	},

	actions: {
		async buscarDadosAtendimento({ idAtendimento, atualizar }) {
			this.carregando = true;
			this.erro = false;

			try {
				const response = await ApiService.buscarDadosAtendimento(idAtendimento, atualizar);

				this.idAtendimentoUrl = idAtendimento;
				this.atendimento = response;
				this.expirado = response.expirado === 'S';

				if (!this.expirado) {
					this.totalServicos = Object.keys(response.servicos || {}).length;
					this.temAnexos = Object.keys(response.anexos || {}).length > 0;
					this.coordenadasAtendimento = CoordenadasAtendimentoService.montarCoordenadasAtendimento(response);

					if (this.totalServicos > 1) {
						let servicosAbertos = {};
						let servicosFinializados = {};

						for (const idServicoAtendimento in response.servicos) {
							if (Object.prototype.hasOwnProperty.call(response.servicos, idServicoAtendimento)) {
								const servico = response.servicos[idServicoAtendimento];
								if (servico.status == 'FINALIZADO' || !isEmpty(servico.dataHorarioChegada)) {
									servicosFinializados[idServicoAtendimento] = servico;
								} else {
									servicosAbertos[idServicoAtendimento] = servico;
								}
							}
						}

						this.atendimento.servicos = Object.assign(servicosAbertos, servicosFinializados);
					}
				}
				
			} catch (error) {
				console.error('Erro ao buscar dados:', error);
				this.erro = true;
				throw error;
			} finally {
				this.carregando = false;
			}
		},

		async marcarChegadaPrestador(idServicoAtendimento, dataHoraChegada) {
			const response = await ApiService.marcarChegadaPrestador(this.idAtendimentoUrl, idServicoAtendimento, dataHoraChegada);
			if (!response.error) {
				this.atendimento.servicos[idServicoAtendimento].dataHorarioChegada = dataHoraChegada;
			}
			return response;
		},

		async confirmarChegadaPrestador(chegou, idServicoAtendimento) {
			const response = await ApiService.confirmarChegadaPrestador(this.idAtendimentoUrl, idServicoAtendimento, chegou);
			if (!response.error) {
				this.chegadaConfirmada = chegou;
			}
			return response;
		},

		async salvarEndereco(tipoEndereco, endereco) {
			let objEndereco = {};
			if (tipoEndereco == 'Origem') {
				objEndereco.origem = endereco;
			}
			if (tipoEndereco == 'Destino') {
				objEndereco.destino = endereco;
			}

			const response = await ApiService.salvarEndereco(this.idAtendimentoUrl, objEndereco);
			this.atendimento[`endereco${tipoEndereco}`] = endereco;

			return response;
		},

		async enviarAnexos(arquivos) {
			const response = await ApiService.enviarAnexos(this.idAtendimentoUrl, arquivos);
			return response;
		},

		async solicitarContato(mensagem, cancelamento) {
			const response = await ApiService.solicitarContato(this.idAtendimentoUrl, mensagem, cancelamento)
			return response;
		},

		/* async cancelarAtendimento(motivo) {
			try {
				this.atendimento.status = 'cancelado';
				this.atendimento.textoStatus = 'Atendimento cancelado';
				this.atendimento.motivoCancelamento = motivo;

				return { sucesso: true, motivo };
			} catch (error) {
				console.error('Erro ao cancelar atendimento:', error);
				throw error;
			}
		} */
	}
});